export default __webpack_public_path__ + "static/media/06_Have-a-picnic.f93663ab.jpg";